import React from 'react'
import styled from 'styled-components'
import theme from '../styles/theme'
import PlatformUserIDs from './PlatformUserIDs'
import TierTagSync from './TierTagSync'

const Container = styled.div`
  background: ${theme.color.background.light};
  padding: 2rem;
  border-radius: 8px;
  box-shadow: inset 0 2px 4px ${theme.color.shadow.light};
`

const Section = styled.div`
  margin-bottom: 3rem;

  &:last-child {
    margin-bottom: 0;
  }
`

const SectionTitle = styled.h3`
  font-size: 2rem;
  font-weight: 700;
  color: ${theme.color.text.base};
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid ${theme.color.border.light};
`

interface SessionMToolsProps {
  userData: any
  marianaTekData: any
  barrysPlatformData: any
}

const SessionMTools: React.FC<SessionMToolsProps> = ({ userData, marianaTekData, barrysPlatformData }) => {
  return (
    <Container>
      <Section>
        <SectionTitle>Platform User IDs</SectionTitle>
        <PlatformUserIDs
          userData={userData}
          marianaTekData={marianaTekData}
          barrysPlatformData={barrysPlatformData}
        />
      </Section>

      <Section>
        <SectionTitle>Bulk Tier Tag Sync</SectionTitle>
        <TierTagSync />
      </Section>
    </Container>
  )
}

export default SessionMTools
